<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Tabs, Tab } from '@Shelly/shelly-design-system';
	//Componets
	import VGroupComponentsV2 from './VGroupComponentsV2.svelte';
	import UserDefinedVComponentsV2 from './UserDefinedVComponentsV2.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';

	export let device: Device;

	let viewComponents = false;
	// The XT1 Module only supports Bluetooth (BTHome) components
	const showCreateButton = !isXT1Module(device.type);
</script>

<Tabs class="mb-m" useNewLayout tabsStyle="segment">
	<Tab
		useNewLayout
		tabsStyle="segment"
		active={!viewComponents}
		on:click={() => {
			viewComponents = false;
		}}
	>
		{$format('toggle_virtual_component_title_view_groups', {
			default: 'Groups',
		})}
	</Tab>
	<Tab
		useNewLayout
		tabsStyle="segment"
		active={viewComponents}
		on:click={() => {
			viewComponents = true;
		}}
	>
		{$format('toggle_virtual_component_title_view_components', {
			default: 'Components',
		})}
	</Tab>
</Tabs>
{#if !viewComponents}
	<VGroupComponentsV2 {device} {showCreateButton} />
{:else}
	<UserDefinedVComponentsV2 {device} {showCreateButton} />
{/if}
